const getError = (target) => {
    const STATE = target.validity;
    const ERROR = target.getAttribute('data-custom-validation');
    if (STATE.valid) {
        return null;
    }
    if (STATE.customError && typeof ERROR === 'string') {
        return `global.validation.error.${ERROR}`;
    }
    for (const KEY in STATE) {
        if (Boolean(STATE[KEY])) {
            return `global.validation.error.${KEY.replace(/(?<upper>[A-Z])/gu, '_$<upper>')}`
                .toLowerCase();
        }
    }
    return 'global.validation.error.generic';
};
const validateSelect = (target) => {
    if (!target.hasAttribute('required') || target.value.length !== 0) {
        target.setCustomValidity('');
        return;
    }
    target.setCustomValidity('value_missing');
};
const validateCustomError = (target) => {
    const ERROR = target.getAttribute('data-custom-validation');
    target.setCustomValidity(ERROR);
};
export const handleInputError = (target) => {
    const CUSTOM_FLAG = 'data-custom-validation';
    if (target.tagName === 'SELECT') {
        validateSelect(target);
    }
    if (target.hasAttribute(CUSTOM_FLAG)) {
        validateCustomError(target);
    }
    return getError(target);
};
